import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { useParams } from 'react-router-dom';
import { tenantPortalAPI } from '../services/api';

const TenantHistory = () => {
  const { orgId } = useParams();
  const [items, setItems] = useState([]);
  const [error, setError] = useState('');

  const authed = !!(localStorage.getItem('tenant_token') || sessionStorage.getItem('tenant_token'));

  useEffect(() => {
    if (!authed) return; // Only load if authenticated
    
    const run = async () => {
      try {
        const data = await tenantPortalAPI.history();
        setItems(data || []);
      } catch (e) {
        setError(e.message || 'Failed to load history');
      }
    };
    run();
  }, [authed]);

  return (
    <div className="p-6 space-y-6">
      {!authed ? (
        <Card>
          <CardContent className="p-6">
            <div className="text-center text-gray-600">
              <p>Please sign in to view your payment history.</p>
            </div>
          </CardContent>
        </Card>
      ) : (
        <Card>
          <CardHeader>
            <CardTitle>Payment History</CardTitle>
          </CardHeader>
          <CardContent>
            {error && <div className="text-sm text-red-600 mb-2">{error}</div>}
            <div className="overflow-x-auto">
              <table className="min-w-full text-sm">
                <thead>
                  <tr className="text-left border-b">
                    <th className="py-2 pr-4">Date</th>
                    <th className="py-2 pr-4">Amount</th>
                    <th className="py-2 pr-4">Method</th>
                    <th className="py-2 pr-4">Status</th>
                    <th className="py-2 pr-4">Txn</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((p)=> (
                    <tr key={p.id || p._id} className="border-b last:border-none">
                      <td className="py-2 pr-4">{new Date(p.paid_date || p.created_at).toLocaleString()}</td>
                      <td className="py-2 pr-4">${p.amount?.toFixed(2)}</td>
                      <td className="py-2 pr-4">{p.method}</td>
                      <td className="py-2 pr-4">{p.status}</td>
                      <td className="py-2 pr-4 text-xs text-gray-500">{p.transaction_id}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default TenantHistory;